module.exports = __webpack_public_path__ + "img/MountainBanner.39104a64.png";